export default __webpack_public_path__ + "static/media/logo_ipvc.00e522fe.png";